import { TooltipTitle } from '@global-engineering-shared/gweb-material-global';
import { InfoIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Box, Tooltip, Typography } from '@global-engineering-shared/gweb-material-ui';

import ChipListDetail from 'features/EntityDetails/components/EntityDetails/ChipListDetail';
import useStyles from 'features/EntityDetails/components/EntityDetails/OperatingHours/OperatingHours.styles';
import {
  formatOperatingHours,
  OperatingHoursKind,
  toChipItems,
} from 'features/EntityDetails/components/EntityDetails/OperatingHours/utils/formatOperatingHours';
import { TOperatingHours } from 'types/detailsEntityType';

const HEADER_TEXT = 'Operating Hours';

export interface IOperatingHoursProps {
  operatingHours: TOperatingHours | null;
  previousOperatingHours?: TOperatingHours | null;
}

const OperatingHours = ({ operatingHours, previousOperatingHours }: IOperatingHoursProps) => {
  const classes = useStyles();
  const view = formatOperatingHours(operatingHours);
  const hasPreviousEntity = previousOperatingHours !== undefined;
  const previousChips = hasPreviousEntity
    ? toChipItems(formatOperatingHours(previousOperatingHours))
    : undefined;

  const currentChips = toChipItems(view);

  if (view.kind === OperatingHoursKind.NOT_FOUND && (!previousChips || !previousChips.length)) {
    return (
      <Box className={classes.notFoundRoot}>
        <Typography variant="body2" className={classes.notFoundLabel}>
          {HEADER_TEXT}
        </Typography>
        <Typography variant="body2" fontWeight={600} className={classes.notFoundValue}>
          Not Found
        </Typography>
      </Box>
    );
  }

  return (
    <ChipListDetail
      headerText={HEADER_TEXT}
      items={currentChips}
      previousItems={previousChips}
      getKey={(item) => item.key}
      getChipClasses={(item) => (item.days ? { label: classes.chipLabelOverride } : undefined)}
      getLabel={(item) => {
        const days = item.days;

        if (!days?.length) {
          return item.label;
        }

        return (
          <span className={classes.chipLabel}>
            <Tooltip
              title={
                <TooltipTitle
                  Content={() => (
                    <Box className={classes.tooltipContentContainer}>
                      {days.map((day) => (
                        <Box key={day.label} className={classes.tooltipContentRow}>
                          <Typography variant="body2">{day.label}:</Typography>
                          <Typography variant="body2b" className={classes.tooltipContentSecondText}>
                            {day.ranges.length ? day.ranges.join(', ') : 'Offline'}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  )}
                />
              }
              placement="bottom-start"
              interactive
            >
              <span className={classes.infoIcon}>
                <InfoIcon />
              </span>
            </Tooltip>
            {item.label}
          </span>
        );
      }}
    />
  );
};

export default OperatingHours;
